import { render, staticRenderFns } from "./LolerIndex.vue?vue&type=template&id=ac4679e2&scoped=true"
import script from "./LolerIndex.vue?vue&type=script&lang=js"
export * from "./LolerIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac4679e2",
  null
  
)

export default component.exports